import React, { useEffect, useState } from "react";
import {
  TableCell,
  TableText,
  TableRow,
} from "../../../../../../Components/FinalTable";
import { convDate } from "../../../../../../Util/Time";
import TableActions from "./TableActions";
import Badge from "../../../../../../Components/Badges/Badge";

import useAxios from "../../../../../../Hooks/useAxios";

const TRow = ({ doc, handleUpdate }) => {
  const request = useAxios();

  const handleRemove = async () => {
    let res = await request({
      url: "diagnosis/visit/delete",
      method: "DELETE",
      params: {
        id: doc.id,
      },
    });

    if (res === "error") {
      return;
    }

    handleUpdate();
  };

  return (
    <>
      <TableRow key={doc.id}>
        <TableCell w={80 / 5}>
          <TableText label={doc?.diagnostics?.code} />
        </TableCell>
        <TableCell w={80 / 5}>
          <TableText label={doc?.diagnostics?.name} />
        </TableCell>
        <TableCell w={80 / 5}>
          <TableText label={doc?.diagnostics?.description || ""} />
        </TableCell>
        <TableCell w={80 / 5}>
          <TableText label={convDate(doc.created_at)} />
        </TableCell>
        <TableCell w={80 / 5}>
          <Badge
            click={handleRemove}
            label={"Delete"}
            bg={"pale_pink"}
            textColor={"red"}
          />
        </TableCell>
      </TableRow>
    </>
  );
};

export default TRow;
